const deepClone2dArray = <T>(arr: T[][]) => arr.map((el) => [...el]);

export default deepClone2dArray;
